/**
 * The apply page. One <squiryl-button>, two stages.
 *
 * The stage switch changes the endpoint the widget posts to, so the SAME package
 * is requested either in full or narrowed to the viewing fields. Narrowing is a
 * decision the agent makes per request; widening is not theirs to make.
 */
import '@squiryl/button';

const btn = document.getElementById('share');
const statusEl = document.getElementById('status');
const quickBtn = document.getElementById('kind-quick');
const fullBtn = document.getElementById('kind-full');
const scopeNote = document.getElementById('scope-note');
const resultEl = document.getElementById('result');
const resultRef = document.getElementById('result-ref');
const resultDetails = document.getElementById('result-details');
const omittedNote = document.getElementById('omitted-note');

const LABELS = {
  first_name: 'First name', last_name: 'Last name', date_of_birth: 'Date of birth',
  nationality: 'Nationality', number_of_dependents: 'Dependants',
  line_1: 'Address', line_2: 'Address line 2', city: 'Town or city',
  postcode: 'Postcode', country: 'Country', email: 'Email', phone_number: 'Phone',
  record_type: 'Immigration record', status: 'Immigration status', expiry_date: 'Expires',
};
const label = (key) => LABELS[key] ?? key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
const esc = (value) =>
  String(value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

const SCOPE_NOTES = {
  quick: `<h4>The viewing enquiry asks for</h4>
    <ul class="field-list">
      <li><span class="tick">✓</span> First and last name</li>
      <li><span class="tick">✓</span> Town, postcode and country</li>
    </ul>
    <p class="small muted">Nothing else is even offered to us at this stage.</p>`,
  full: `<h4>The full application asks for</h4>
    <ul class="field-list">
      <li><span class="tick">✓</span> Name, date of birth and nationality — required</li>
      <li><span class="tick">✓</span> Address, email and phone — required</li>
      <li><span class="tick">○</span> Dependants, second address line, immigration details — optional</li>
    </ul>
    <p class="small muted">You can leave every optional field out and still apply.</p>`,
};

function setStage(kind) {
  // The stage is part of the MOUNT PATH. The widget appends '/session' to this
  // value, so a query string here would produce '/squiryl?kind=quick/session'.
  btn.setAttribute('endpoint', kind === 'quick' ? '/squiryl/quick' : '/squiryl');
  quickBtn.className = kind === 'quick' ? 'btn btn-primary btn-sm' : 'btn btn-ghost btn-sm';
  fullBtn.className = kind === 'full' ? 'btn btn-primary btn-sm' : 'btn btn-ghost btn-sm';
  scopeNote.innerHTML = SCOPE_NOTES[kind];
  statusEl.textContent = 'Press the button, then approve on your phone.';
  resultEl.hidden = true;
}

quickBtn.addEventListener('click', () => setStage('quick'));
fullBtn.addEventListener('click', () => setStage('full'));
setStage('quick');

btn.addEventListener('squiryl:share', (event) => {
  const { payload } = event.detail;
  if (!payload) {
    statusEl.textContent = 'You approved, but the encrypted details never reached us. Please try again.';
    return;
  }

  const rows = [];
  for (const [section, fields] of Object.entries(payload)) {
    if (!fields || typeof fields !== 'object' || section === 'captured_at') continue;
    for (const [field, value] of Object.entries(fields)) {
      if (value === null || value === undefined || value === '') continue;
      rows.push(`<dt>${esc(label(field))}</dt><dd>${esc(value)}</dd>`);
    }
  }
  resultDetails.innerHTML = rows.join('');
  resultRef.textContent = `${rows.length} fields`;
  statusEl.textContent = 'Thank you. We have what we need.';
  resultEl.hidden = false;

  // The agent's own view knows which optional fields were declined; the applicant
  // is told plainly that declining them cost nothing.
  omittedNote.hidden = false;
  omittedNote.textContent =
    'Anything you chose not to share was optional. Your application is complete without it.';
});

btn.addEventListener('squiryl:declined', () => { statusEl.textContent = 'You declined. Nothing was shared.'; });
btn.addEventListener('squiryl:expired', () => { statusEl.textContent = 'The request expired. Press the button again.'; });
btn.addEventListener('squiryl:error', (event) => { statusEl.textContent = `Something went wrong: ${event.detail.error}`; });
